import { render, staticRenderFns } from "./dev-environments.vue?vue&type=template&id=0ac63b31&scoped=true"
import script from "./dev-environments.vue?vue&type=script&lang=js"
export * from "./dev-environments.vue?vue&type=script&lang=js"
import style0 from "./dev-environments.vue?vue&type=style&index=0&id=0ac63b31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac63b31",
  null
  
)

export default component.exports